import { CookieConf } from "@/libs/config";

export default {
    setCookie: function(cname, cvalue, exhours) {
        var cookieArray = [];
        var d = new Date();

        d.setTime(d.getTime() + exhours * 60 * 60 * 1000);

        cookieArray.push(cname + "=" + cvalue + ";");
        cookieArray.push("expires=" + d.toUTCString() + ";");
        cookieArray.push("path=/;");

        // 生产环境 cookie 需存在一级域名，才能实现 cookie 跨域
        if (process.env.NODE_ENV === "production") {
            cookieArray.push("domain=" + CookieConf.domain + ";");
        }

        document.cookie = cookieArray.join("");
    },
    getCookie: function(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];

            while (c.charAt(0) === " ") {
                c = c.substring(1);
            }

            if (c.indexOf(name) !== -1) {
                return c.substring(name.length, c.length);
            }
        }

        return "";
    },
    // 删除cookie
    removeCookie: function(cookieName) {
        this.setCookie(cookieName, "", -1);
    },
    clearCookie: () => {
        var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
        if (keys) {
            for (let i = keys.length; i--;) {
                document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString();//清除当前域名下的,例如：m.kevis.com
                document.cookie = keys[i] + '=0;path=/;domain=' + document.domain + ';expires=' + new Date(0).toUTCString();//清除当前域名下的，例如 .m.kevis.com
                document.cookie = keys[i] + '=0;path=/;domain=kevis.com;expires=' + new Date(0).toUTCString();//清除一级域名下的或指定的，例如 .kevis.com
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/libs/utils/cookie.js